module.exports = __webpack_public_path__ + "static/media/cloud.9d433a6f.png";